import { IconProps } from '../Icons.type'

export function SearchIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3 9.05833L15.075 13.8333L13.8333 15.075L9.05833 10.3C8.16667 10.9417 7.09167 11.3333 5.91667 11.3333C2.925 11.3333 0.5 8.90833 0.5 5.91667C0.5 2.925 2.925 0.5 5.91667 0.5C8.90833 0.5 11.3333 2.925 11.3333 5.91667C11.3333 7.09167 10.9417 8.16667 10.3 9.05833ZM5.91667 2.16667C3.84167 2.16667 2.16667 3.84167 2.16667 5.91667C2.16667 7.99167 3.84167 9.66667 5.91667 9.66667C7.99167 9.66667 9.66667 7.99167 9.66667 5.91667C9.66667 3.84167 7.99167 2.16667 5.91667 2.16667Z"
        fill="currentColor"
      />
    </svg>
  )
}
